import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "flex justify-center my-1" }
const _hoisted_3 = { class: "flex flex-col sm:justify-between items-center sm:flex-row mt-12 sm:mt-10 mb-5 sm:mb-8" }
const _hoisted_4 = { class: "w-full md:w-1/3 text-left" }
const _hoisted_5 = { class: "font-general-semibold text-3xl md:text-3xl xl:text-4xl text-center sm:text-left text-ternary-dark dark:text-primary-light uppercase" }
const _hoisted_6 = { class: "font-general-medium mt-2 text-lg sm:text-xl xl:text-2xl text-center sm:text-left leading-none text-gray-400 px-5 lg:px-0" }
const _hoisted_7 = ["download", "href", "aria-label", "data-tip"]
const _hoisted_8 = { class: "text-sm sm:text-lg font-general-medium duration-100" }
const _hoisted_9 = { class: "flex justify-center mb-2" }
const _hoisted_10 = { class: "text-3xl md:text-3xl xl:text-4xl text-center" }
const _hoisted_11 = { class: "flex justify-center mb-5" }
const _hoisted_12 = { class: "flex justify-center mb-5" }
const _hoisted_13 = { class: "flex justify-center mb-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DevAnimated = _resolveComponent("DevAnimated")!
  const _component_Cards = _resolveComponent("Cards")!
  const _component_Stats = _resolveComponent("Stats")!
  const _component_DownloadApp = _resolveComponent("DownloadApp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('hi-i-am')), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('skills')), 1),
          _createElementVNode("div", null, [
            _createElementVNode("a", {
              download: _ctx.currentCV.url,
              href: _ctx.currentCV.url,
              "aria-label": _ctx.currentCV.name,
              "data-tip": _ctx.currentCV.name,
              class: "flex justify-center items-center tooltip tooltip-bottom w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-sky-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-sky-50 focus:ring-1 focus:ring-sky-900 hover:bg-sky-500 text-gray-500 hover:text-white duration-500",
              target: "_blank"
            }, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('download-cv')) + " - [" + _toDisplayString(_ctx.currentCV.lang.toUpperCase()) + "] ", 1)
            ], 8, _hoisted_7)
          ])
        ]),
        _createVNode(_component_DevAnimated)
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.$t('projects-portfolio')), 1)
    ]),
    _createElementVNode("section", _hoisted_11, [
      (_ctx.projects)
        ? (_openBlock(), _createBlock(_component_Cards, {
            key: 0,
            projects: _ctx.projects
          }, null, 8, ["projects"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_12, [
      false
        ? (_openBlock(), _createBlock(_component_Stats, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_13, [
      false
        ? (_openBlock(), _createBlock(_component_DownloadApp, { key: 0 }))
        : _createCommentVNode("", true)
    ])
  ]))
}